const mapDispatchToProps = (dispatch) => {
    return{
        dispatchProps: {
            setFirstNumber: (firstNumber) => (
                dispatch({ type: "SET_FIRST_NUMBER", payload: firstNumber })
            ),
            setSecondNumber: (secondNumber) => (
                dispatch({ type: "SET_SECOND_NUMBER", payload: secondNumber })
            ),
            setFirstOpuest: (firstOpuest) => (
                dispatch({ type: "SET_FIRST_OPUEST", payload: firstOpuest })
            ),
            setSecondOpuest: (secondOpuest) => (
                dispatch({ type: "SET_SECOND_OPUEST", payload: secondOpuest })
            ),
            setComma: (comma) => (
                dispatch({ type: "SET_COMMA", payload: comma })
            ),
            setOperation: (operation) => (
                dispatch({ type: "SET_OPERATION", payload: operation })
            ),
            setResult: (result) => (
                dispatch({ type: "SET_RESULT", payload: result })
            ),
            setHistory: (firstNumber) => (
                dispatch({ type: "SET_HISTORY", payload: firstNumber })
            ),
            setScreenInitial: (screenInitial) => (
                dispatch({ type: "SET_SCREEN_INITIAL", payload: screenInitial })
            ),
            setScreenStop: (screenStop) => (
                dispatch({ type: "SET_SCREEN_STOP", payload: screenStop })
            ),    
        }    
    };
}

export default mapDispatchToProps;